import { forwardRef, useRef } from "react";

import Grid from "@mui/material/Grid";
import { Nullable } from "@simplyk/common";

import { CompleteEmailRecipientsInput } from "./EmailRecipientsInput/CompleteEmailRecipientsInput";
import { EmailRecipientsFieldProps, EmailRecipientsInputRef } from "./types";

import { BulkProviderRef } from "@/common/contexts/BulkContext";

declare global {
  interface Window {
    clipboardData: { getData?: (key: string) => string };
  }
}

export const EmailRecipientsField = forwardRef(
  ({
    recipientEmails,
    updateRecipientEmails,
    onDrawerOpen,
    disabled,
    inputOnly,
    noValidation,
    contactLists,
  }: EmailRecipientsFieldProps) => {
    const emailRecipientInputRef = useRef<Nullable<EmailRecipientsInputRef>>(null);

    const handleOpenDrawer = () => {
      if (disabled) {
        return;
      }

      onDrawerOpen?.();
    };

    const handleUpdateEmails = async (recipientEmails: string[]) => {
      await updateRecipientEmails?.(recipientEmails);
      bulkSelectRef.current?.resetDefaultValues(recipientEmails);
    };

    const bulkSelectRef = useRef<BulkProviderRef>(null);

    return (
      <Grid item xs={12}>
        <CompleteEmailRecipientsInput
          onChangeRecipients={handleUpdateEmails}
          disabled={disabled}
          defaultRecipientEmails={recipientEmails}
          handleOpenDrawer={handleOpenDrawer}
          inputOnly={inputOnly}
          noValidation={noValidation}
          contactLists={contactLists}
          ref={emailRecipientInputRef}
        />
      </Grid>
    );
  }
);

EmailRecipientsField.displayName = "EmailRecipientsField";
